export default "__VITE_ASSET__C18Nk5xo__"